// extracted by mini-css-extract-plugin
export default {"Main":"Layout_Main__JDqvx","WholeScreen":"Layout_WholeScreen__sZaMy"};